import { ArrowLeft } from "lucide-react";

const TITOLARE = {
  nome: "Alassane Diallo",
  attivita: "Protezione Patrimoniale",
  sede: "Bergamo (BG), Italia",
  email: "info@alassane-diallo.it",
};

const Section = ({ n, title, children }) => (
  <section className="mt-8" data-testid={`privacy-section-${n}`}>
    <h2 className="font-serif text-2xl text-white">{n}. {title}</h2>
    <div className="mt-3 text-zinc-400 leading-relaxed space-y-3 text-sm">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  const acc = "#D4AF37";
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors" data-testid="privacy-back">
          <ArrowLeft size={16} /> Torna al sito
        </a>

        <h1 className="font-serif text-4xl sm:text-5xl mt-8">Informativa sulla Privacy</h1>
        <p className="mt-3 text-sm text-zinc-500">Ultimo aggiornamento: 10 luglio 2026 · Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003.</p>

        <Section n="1" title="Titolare del trattamento">
          <p>
            Il Titolare del trattamento dei dati è <strong className="text-white">{TITOLARE.nome}</strong> ({TITOLARE.attivita}),
            con sede in {TITOLARE.sede}.
          </p>
          <p>Per qualsiasi richiesta relativa alla privacy puoi scrivere a: <a href={`mailto:${TITOLARE.email}`} className="underline" style={{ color: acc }}>{TITOLARE.email}</a>.</p>
        </Section>

        <Section n="2" title="Quali dati raccogliamo">
          <p>Attraverso il modulo di richiesta del Report "Piano Azione" raccogliamo i dati personali che ci fornisci volontariamente:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Nome e cognome</li>
            <li>Indirizzo email</li>
            <li>Numero di telefono</li>
            <li>Informazioni facoltative inserite nel calcolo (importo, orizzonte temporale) usate solo per generare il report</li>
          </ul>
        </Section>

        <Section n="3" title="Finalità e base giuridica">
          <p>I dati vengono trattati per le seguenti finalità:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Ricontattarti a seguito della tua richiesta (base giuridica: consenso dell'interessato, art. 6.1.a GDPR);</li>
            <li>Fornirti il report e le informazioni richieste;</li>
            <li>Adempiere a eventuali obblighi di legge.</li>
          </ul>
          <p>Il conferimento dei dati è facoltativo, ma il mancato conferimento impedisce di dar seguito alla richiesta.</p>
        </Section>

        <Section n="4" title="Modalità e conservazione">
          <p>I dati sono trattati con strumenti elettronici, adottando misure di sicurezza adeguate a prevenire accessi non autorizzati. I dati sono conservati per il tempo strettamente necessario alle finalità indicate e comunque non oltre i termini previsti dalla legge; potrai richiederne la cancellazione in qualsiasi momento.</p>
        </Section>

        <Section n="5" title="Comunicazione dei dati">
          <p>I dati non vengono diffusi né ceduti a terzi per finalità di marketing. Possono essere trattati da fornitori tecnici che agiscono come responsabili del trattamento (es. servizio di invio email e hosting), esclusivamente per l'erogazione del servizio.</p>
        </Section>

        <Section n="6" title="Diritti dell'interessato">
          <p>In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15-22 del GDPR: accesso, rettifica, cancellazione, limitazione, opposizione al trattamento e portabilità dei dati, nonché revocare il consenso prestato. Per esercitarli scrivi a <a href={`mailto:${TITOLARE.email}`} className="underline" style={{ color: acc }}>{TITOLARE.email}</a>. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).</p>
        </Section>

        <Section n="7" title="Cookie">
          <p>Questo sito utilizza esclusivamente cookie tecnici necessari al funzionamento e alla navigazione. Non vengono utilizzati cookie di profilazione o di marketing di terze parti. Poiché non vengono impiegati cookie di tracciamento, non è richiesto alcun consenso preventivo ai sensi delle Linee Guida del Garante.</p>
        </Section>

        <p className="mt-12 text-xs text-zinc-600">
          Questo testo è un modello informativo di base. Ti consigliamo di farlo verificare da un consulente/legale per adattarlo pienamente alla tua situazione specifica.
        </p>
      </div>
    </div>
  );
}
